import { QREmail } from "./qr-email";

export { QREmail };
